const MAP = {
  verde: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", dot: "bg-emerald-500", label: "Riesgo bajo" },
  amarillo: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", dot: "bg-amber-500", label: "Riesgo medio" },
  rojo: { bg: "bg-red-50", text: "text-red-700", border: "border-red-200", dot: "bg-red-500", label: "Riesgo alto" },
};

export const RiskBadge = ({ color = "verde", level, score, size = "md" }) => {
  const s = MAP[color] || MAP.verde;
  const pad = size === "lg" ? "px-3.5 py-2 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid="risk-badge"
      className={`inline-flex items-center gap-2 rounded-md border font-bold ${s.bg} ${s.text} ${s.border} ${pad}`}
    >
      <span className={`h-2 w-2 rounded-full ${s.dot}`} />
      {level ? `Riesgo ${level}` : s.label}
      {score != null && <span className="opacity-70 font-mono-tf">· {score}</span>}
    </span>
  );
};
